<div class="pt-4 pb-3 wrapper-editor">
  <div class="position-relative">
    <label class="position-absolute label-property">
      <div
        [ngStyle]="{'background': disabled ? 'linear-gradient(0deg, rgba(230,230,230,1) 30%, rgba(255,255,255,1) 50%)' : 'white'}"
        class="text">
        {{ title! | translate }}
        <span style="color: red;">{{ required ? '*' : '' }}</span>
      </div>
    </label>
    <angular-editor
      (ngModelChange)="onEditorChange($event)"
      [(ngModel)]="value"
      [config]="editorConfig"
      [disabled]="disabled"
    ></angular-editor>
  </div>
</div>
